import type { Servicio } from '@/types/database'

/**
 * El precio de referencia se muestra y se guarda si hay permiso y el formulario lo leyó. En el alta no
 * hay nada que leer. Al editar, un servicio que llegó sin la columna precio_estimado no lo trae: el
 * campo vacío mandaría null encima del precio real.
 */
export const precioEditable = (verHonorariosCliente: boolean | undefined, servicio?: Servicio | null) =>
  verHonorariosCliente === true && (!servicio || 'precio_estimado' in servicio)
